<template>
  <router-link
    :to="routers.assessRecommend"
    class="tw-flex tw-w-full tw-items-center tw-justify-between tw-cursor-pointer !tw-no-underline"
    @click.stop="$emit('close-menu')"
  >
    <div
      class="tw-flex tw-min-h-[50px] tw-justify-center tw-items-center tw-gap-[25px]"
    >
      <span class="recommend-topic-title">{{ data?.checklistGroupName }}</span>
      <StatusBadge :value="statusCode.significant" class="tw-w-fit" />
    </div>
    <IconRight />
  </router-link>
</template>

<script setup lang="ts">
import { routers } from "@/utils/constants";
import { statusCode } from "@/utils/constants";

/** components */
import IconRight from "@/components/common/globalSearch/menuSearch/iconChevronRight.vue";
import StatusBadge from "@/components/common/setting/statusBadge.vue";

const props = defineProps<{
  data: any;
}>();

const emit = defineEmits<{
  (e: "close-menu"): void;
}>();
</script>

<style scoped>
.recommend-topic-title {
  font-family: Poppins, sans-serif;
  font-size: 13px;
  font-weight: 500;
  color: #387dff;
  user-select: none;
}
</style>
